<template>
    <div class="fw-jddsh">
        <div class="sousuo">
            <div class="sou-item">
                <van-search
                        v-model="phone"
                        placeholder="请输入手机号搜索"
                        shape="round"
                >
                </van-search>
            </div>
        </div>
        <Cxdate @chaxun="chaxun"/>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <div class="oo-items" v-for="(item,index) in list">
                <div class="mbinfo" style="border-bottom: #C0BEC0 solid 0px;">
                    <div>
                        <img v-if="item.headPortrait" :src="item.headPortrait" class="my-tou"/>
                        <div v-else>
                            <img v-if="item.sex==0" src="../../../assets/nan.png" class="my-tou"/>
                            <img v-if="item.sex==1" src="../../../assets/nan.png" class="my-tou"/>
                            <img v-if="item.sex==2" src="../../../assets/nv.png" class="my-tou"/>
                        </div>
                    </div>
                    <div class="my-mbinfo">
                        <span>{{item.memberName}}</span>
                        <span style="font-size: 10px;">{{item.phone}}</span>
                    </div>
                </div>
                <div class="ooinfo">
                    <div class="ooinfo-item">
                        <span class="oi-name">订单编号:</span>
                        <span class="oi-val">{{item.orderNo}}</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">支付时间:</span>
                        <div class="mmdd">
                            <span class="oi-val">{{item.payTime}}</span>
                            <span class="oi-val1" v-if="!item.payStatus||item.payStatus==0">未支付</span>
                            <span class="oi-val1" v-if="item.payStatus==1">已支付</span>
                        </div>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">支付方式:</span>
                        <span class="oi-val" v-if="item.payType==0">微信支付</span>
                        <span class="oi-val" v-if="item.payType==2">金豆支付</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">配送方式:</span>
                        <span class="oi-val" v-if="item.shippingType==0">到店</span>
                        <span class="oi-val" v-if="item.shippingType==1">快递</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">订单状态:</span>
                        <span class="oi-val" v-if="item.orderStatus==1">待发货</span>
                        <span class="oi-val" v-if="item.orderStatus==2">已发货</span>
                        <span class="oi-val" v-if="item.orderStatus==3">已完成</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">手机号码:</span>
                        <span class="oi-val">{{item.phone}}</span>
                    </div>
<!--                    <div class="ooinfo-item">-->
<!--                        <span class="oi-name">收货地址:</span>-->
<!--                        <span class="oi-val">{{item.address}}</span>-->
<!--                    </div>-->
                    <div>
                        <span class="odbt"></span>
                        <div >
                            <div class="goodsitem" v-for="goods in item.goodsItems">
                                <span>{{goods.itemName}}</span>
                                <span>x{{goods.total}}</span>
                            </div>
                            <div style="font-size: 13px;margin-top: 10px;display: flex;flex-direction: column;color: #F03CA6">
                               <span style="height: 23px;line-height: 23px">发货人:{{item.userName}} {{item.userPhone}}</span>
                               <span style="height: 23px;line-height: 23px">发货时间:{{item.deliveryTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import {getCookie,} from "../../../utils/auth";
    import Cxdate from "../../common/cxdate.vue";

    export default {
        components: {Cxdate},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',

                dateType: 0,
                staDate: '',
                endDate: '',
                phone:'',
                list: [],
                loading: false,
                finished: false,
                page: 1,
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            // this.userType = this.fwUser.userType
        },
        methods: {
            chaxun(data) {
                this.dateType = data.dateType
                this.staDate = data.staDate
                this.endDate = data.endDate
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            onSearch() {
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            async onLoad() {
                let currentPage = this.page || 1;
                let data = {
                    token: this.token,
                    dateType:this.dateType,
                    staDate :this.staDate,
                    endDate :this.endDate,
                    shippingType:1,
                    orderStatus:2,
                    phone :this.phone,
                    reviewStatus:2,
                    currentPage
                }
                let res = await this.$get("/fw/getYfhOrderList", data)
                if (res.code == 200) {
                    const count =res.dataSet.list.length
                    const newList =res.dataSet.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
            },
            //去重
            quchong(arr, property) {
                const seen = new Set();
                return arr.filter(item => {
                    const key = item[property];
                    return !seen.has(key) && seen.add(key);
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-jddsh {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-bottom: 49px;
    }

    .mbinfo {
        display: flex;
        flex-direction: row;
        padding: 10px;
    }

    .my-tou {
        height: 40px;
        width: 40px;
    }

    .my-mbinfo {
        display: flex;
        flex-direction: column;
    }

    .jd-items {
        padding: 10px;
        margin-top: 5px;
        background-color: #FFFFFF;
    }

    .sousuo {
        background-color: #FFFFFF;
        padding-top: 10px;
    }

    .sou-item {
        padding: 0 28px;
    }
    .mbinfo {
        display: flex;
        flex-direction: row;
        padding: 10px 10px 0 10px;
        border-bottom: #C0BEC0 solid 1px;
    }

    .my-tou {
        height: 40px;
        width: 40px;
    }

    .my-mbinfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .my-mbinfo span {
        font-size: 13px;
        height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 16px
    }

    .oo-items {
        background-color: #FFFFFF;
        margin: 10px;
        padding: 0 8px;
    }

    .ooinfo {
        padding: 8px 16px;
    }

    .ooinfo-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 11px;
    }
    .mmdd{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 11px;
        width: 80%;
    }

    .oi-name {
        width: 55px;
        height: 35px;
        line-height: 35px;
    }

    .oi-val {
        height: 35px;
        line-height: 35px;
    }
    .oi-val1{
        width: 60px;
        text-align: center;
        padding: 3px;
        background-color: #212121;
        color: #FFFFFF;
    }

    .oi-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-top: 10px;
        padding-bottom: 20px;
    }

    .oi-bi1 {
        background-color: #FD99B0;
        width: 100px;
        height: 28px;
        color: #FFFFFF;
        border-radius: 5px;
        font-size: 12px;
        margin: 0 20px;
    }

    .oi-bi2 {
        background-color: #9086DF;
        width: 100px;
        height: 28px;
        color: #FFFFFF;
        border-radius: 5px;
        font-size: 12px;
        margin: 0 20px;
    }
    .odbt {
        display: block;
        font-size: 13px;
        border-bottom: #DDDCDD solid 1px;
    }

    .goodsitem {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 12px;
        height: 35px;
        line-height: 35px;
    }
</style>